import axios from 'axios';
import { ApiUrl } from '../services/ApiRest';
import React, { Component } from 'react'
import Cookies from 'universal-cookie';
import { 
    NavLink as Link,
    withRouter
} from 'react-router-dom';


const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/"; //pasar id del estudiante
const idAdministrativo = cookie.get("idAdministrativo");    //declaramos una variable para usar la cookie del login

class SidebarSecretaria extends Component {

    componentDidMount() {
        // Get que devuelve los datos de un estudiante recibiendo un id
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data;
                this.setState({ estudiante });
                //console.log(estudiante);

                cookie.set('nombres', estudiante.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', estudiante.apellidos_administrativo, { path: "/" })

                // console.log(cookie.get("nombres"));
                // console.log(cookie.get("apellidos")); 
            })
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (
            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav
                    className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft"
                    id="sidenavAccordion"
                >
                    <div className="sb-sidenav-menu px-2 pt-3">
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p className="text-white">Personal de Secretaría</p>
                        </div>

                        <Link to="/secretaria" className="nav-link-custom">
                            <i className="fas fa-home me-2"></i>
                            Página Principal A
                        </Link>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapsePerfilSec"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-user me-2"></i>
                                    Perfil
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapsePerfilSec">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/Secretaria/VerPerfilSecre" className="nav-sub-link">
                                        Ver Perfil
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseMatriculasSec"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i>
                                    Matrículas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseMatriculasSec">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/Secretaria/MatricularEstudiante" className="nav-sub-link">
                                        Matricular Estudiantes
                                    </Link>
                                    <Link to="/Secretaria/MatricularEstudianteGeneral" className="nav-sub-link">
                                        Matricular Estudiante General
                                    </Link>
                                    <Link to="/Secretaria/MatriculasPeriodo" className="nav-sub-link">
                                        Modificar Matrículas
                                    </Link>
                                    <Link to="/Secretaria/MatriculasCoord" className="nav-sub-link">
                                        Matrículas Coordinación
                                    </Link>
                                    <Link to="/Secretaria/MatrizMatriculados" className="nav-sub-link">
                                        Matriz de Matriculados
                                    </Link>
                                    <Link to="/Secretaria/GenerarMatriPdf" className="nav-sub-link">
                                        Generar Matrícula PDF
                                    </Link>
                                    <Link to="/Secretaria/PaseCicloEstCarreraCicloPerio" className="nav-sub-link">
                                        Generar Pase Ciclo PDF
                                    </Link>
                                    <Link to="/Secretaria/ListEstudEstadoMatricula" className="nav-sub-link">
                                        Lista de Estudiantes – Estado Mat.
                                    </Link>
                                    <Link to="/Secretaria/CambiarDatosEstud" className="nav-sub-link">
                                        Cambiar Correo
                                    </Link>
                                    <Link to="/Secretaria/CantidadMatriculados" className="nav-sub-link">
                                        Cantidad de Matriculados
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseCalifSec"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-graduation-cap me-2"></i>
                                    Calificaciones
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseCalifSec">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/Secretaria/CalificacionesEstud" className="nav-sub-link">
                                        Calif. Periodo Carrera
                                    </Link>
                                    <Link to="/Secretaria/Record" className="nav-sub-link">
                                        Acta de Calificaciones
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseAsignSec"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="far fa-sticky-note me-2"></i>
                                    Asignaturas
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseAsignSec">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/Secretaria/ListarAsignaturasDocSec" className="nav-sub-link">
                                        Calif. Asignaturas Docente
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseDocSec"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fa fa-folder me-2"></i>
                                    Documentación
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseDocSec">
                                <nav className="nav flex-column ms-3">
                                    <Link to="/Secretaria/estaddocumenmatriculas" className="nav-sub-link">
                                        Estado Docs. Matrículas
                                    </Link>
                                    <Link to="/Secretaria/actacompromiso" className="nav-sub-link">
                                        Acta de Compromiso
                                    </Link>
                                    <Link to="/Secretaria/fotocarnetestud" className="nav-sub-link">
                                        Fotografías – Carnet
                                    </Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario: <br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>
        )
    }
}

export default withRouter(SidebarSecretaria);